  import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@flaticon/flaticon-uicons/css/regular/rounded.css';
import '@flaticon/flaticon-uicons/css/solid/rounded.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/native-app.css';
import './styles/mobile-redesign.css';
import { initNativeApp } from './shared/native/nativeApp';

void initNativeApp();

// Auto-reload on chunk load failure (stale deployment cache)
function triggerChunkReload() {
  const reloadKey = 'chunk_reload_ts';
  let lastReload = 0;
  try {
    lastReload = Number(sessionStorage.getItem(reloadKey) || 0);
  } catch {
    // Ignore storage errors
  }
  // Only reload once per 30 seconds to avoid infinite reload loops
  if (Date.now() - lastReload > 30000) {
    try {
      sessionStorage.setItem(reloadKey, String(Date.now()));
      const url = new URL(window.location.href);
      url.searchParams.set('_v', Date.now().toString());
      window.location.replace(url.toString());
    } catch {
      window.location.reload();
    }
  }
}

window.addEventListener('error', (event) => {
  const msg = event.message || '';
  if (
    msg.includes('ChunkLoadError') ||
    msg.includes('Loading chunk') ||
    msg.includes('MIME type') ||
    msg.includes('is not executable') ||
    msg.includes('Failed to fetch dynamically imported module')
  ) {
    triggerChunkReload();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const msg = reason?.message || String(reason || '');
  if (
    reason?.name === 'ChunkLoadError' ||
    msg.includes('Loading chunk') ||
    msg.includes('MIME type') ||
    msg.includes('is not executable') ||
    msg.includes('Failed to fetch dynamically imported module')
  ) {
    triggerChunkReload();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

(window as any).__REACT_APP_MOUNTED__ = true;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
